<div class="About">
  <h2>About Spectrum Database</h2>
  <a href="javascript:void(0)" class="Button Button--blue" (click)="goBack()">Back</a>
  <div class="Block">
    <p>The spectrum database contains information on licences for radio spectrum that can be used for mobile technologies (2G, 3G, 4G, 5G).</p>
    <p>It covers national licences and, in some countries, the main regional and local licences.</p>
  </div>
  <div class="Block" *ngIf="aboutData.counts">
    <h3>Spectrum Database in figures:</h3>
    <ul class="List">
      <li><b>{{ aboutData.counts.LICENCE }}</b> licences awarded from <b>{{ aboutData.counts.MIN_DATE }}</b> and valid up to <b>{{ aboutData.counts.MAX_DATE }}</b></li>
      <li><b>{{ aboutData.counts.AWARD }}</b> licence awards</li>
      <li><b>{{ aboutData.counts.COUNTRY }}</b> countries</li>
      <li><b>{{ aboutData.counts.BAND }}</b> bands from <b>{{ aboutData.counts.BAND_GROUP }}</b> groups of bands</li>
    </ul>
  </div>
  <div class="Block">
    <h3>The database can be searched by licences or by awards:</h3>
    <ul class="List">
      <li>A search by licence will show the licences that are currently in force. In newly opened spectrum bands (such as the 3.5 GHz band), the database may also contain licences that have already been awarded for use with mobile technologies but that are not yet in force</li>
      <li>A search by award will allow a comparison of the MHz of spectrum awarded and the prices paid in past awards, with an outlook on future proposed awards. For most awards, the database also has more detailed information, for example, on the auction format or coverage obligations, as well as links to more detailed Cullen reports (currently available only for Europe)</li>
    </ul>
  </div>
  <div class="Block">
    <h3>Features:</h3>
    <ul class="List">
      <li>A search filter is available at all times to navigate to more detailed information on the desired country, band or group of bands</li>
      <li>Many of the database views can be sorted simply by clicking on the column title</li>
      <li>In certain licence views, a graph button allows the dynamic calculation and display of the frequency distribution</li>
      <li>Licence fee prices can be displayed either in USD ($) or EURO (€). The conversion rate is the average of the previous quarter’s exchange rate at the date of the licence (or award)</li>
      <li>The application is responsive and easily usable on mobile</li>
    </ul>
  </div>
  <div class="Block">
    <h3>The database can be filtered by:</h3>
    <ul class="List">
      <li>Region: Europe and/or Americas, depending on which regions are covered by your subscription</li>
      <li>Country</li>
      <li>Group of bands (<1 GHz, 1-3 GHz, 3-6 GHz, >24 GHz) and/or</li>
      <li>Spectrum band</li>
    </ul>
  </div>
  <div class="Block">
    <h3>Units:</h3>
    <p>The abbreviation <b>m</b> is used for million (1m = 1,000,000) and <b>bn</b> is used for billion (1bn = 1,000,000,000).</p>
    <p>Eg. $36.40bn</p>
  </div>
  <div class="Block">
    <h3>Usability:</h3>
    <p>For ease of navigation, most of the titles are clickable, directing you to the desired information.</p>
  </div>
  <div class="Block">
    <h3>Feedback:</h3>
    <p>We are always looking to improve our services to help clients. Do not hesitate to send us feedback and ideas at <a href="mailto:helpdesk@cullen-international.com">helpdesk&#64;cullen-international.com</a>.</p>
  </div>
</div>
